var _defs, _path, _circle, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.2266,25.9993c.082-.656,.1435-1.3222,.1435-1.9988s-.0615-1.3427-.1435-1.9988l4.3358-3.3927c.3895-.3075,.5022-.861,.246-1.312l-4.1-7.1033c-.2563-.4407-.7892-.6253-1.2505-.4407l-5.1045,2.0603c-1.0558-.8098-2.214-1.4965-3.4645-2.0193l-.7688-5.4325c-.0922-.4817-.5125-.861-1.025-.861h-8.2c-.5125,0-.9327,.3792-1.0147,.861l-.7688,5.4325c-1.2391,.5168-2.4041,1.1958-3.4645,2.0193l-5.1045-2.0603c-.4685-.1788-.9976,.0077-1.2505,.4407l-4.1,7.1033c-.2563,.4407-.1435,.9942,.246,1.312l4.3255,3.3927c-.0893,.6626-.1372,1.3302-.1435,1.9988,0,.6765,.0615,1.3427,.1435,1.9988l-4.3255,3.3927c-.3895,.3075-.5023,.861-.246,1.312l4.1,7.1033c.2562,.4407,.7893,.6252,1.2505,.4407l5.1045-2.0603c1.0558,.8097,2.214,1.4965,3.4645,2.0193l.7688,5.4325c.082,.4817,.5022,.861,1.0147,.861h8.2c.5125,0,.9327-.3793,1.0147-.861l.7688-5.4325c1.2391-.5168,2.4041-1.1958,3.4645-2.0193l5.1045,2.0603c.4685,.1788,.9976-.0077,1.2505-.4407l4.1-7.1033c.2563-.4407,.1435-.9942-.246-1.312l-4.3255-3.3927Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 23.9951,
    cy: 24.0005,
    r: 9.264
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 23.9951,
    y1: 14.7365,
    x2: 42.1348,
    y2: 14.7365
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 31.0115,
    y1: 30.0567,
    x2: 19.1591,
    y2: 44.1818
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.7636,
    y1: 22.0017,
    x2: 16.2545,
    y2: 29.0921
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.b4fd5b421d89841349c0bc2309362db3.svg";
export { ForwardRef as ReactComponent };